import { useCallback, useEffect, useState } from 'react';

const useNavigatorOnline = (setOnline?: (_online: boolean) => void) => {
  const [isOnline, setIsOnline] = useState(true);

  const online = useCallback(() => {
    setOnline?.(true);
    setIsOnline(true);
  }, [setOnline]);
  const offline = useCallback(() => {
    console.warn('The network connection has been lost.');
    setOnline?.(false);
    setIsOnline(false);
  }, [setOnline]);

  useEffect(() => {
    setIsOnline(window.navigator.onLine);
    window.addEventListener('online', online);
    window.addEventListener('offline', offline);

    return () => {
      window.removeEventListener('online', online);
      window.removeEventListener('offline', offline);
    };
  }, [offline, online]);

  return isOnline;
};

export default useNavigatorOnline;
